<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel', isDisabled: loading, buttonStyle: 'underline' },
    { text: 'Save', isDisabled: loading, spin: loading }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <mat-dialog-content infiniteScroll [scrollWindow]="false" (scrolled)="getSkuWithDuplicateAsin(false)">
    <div class="unmapped-box pt-3 pb-0" *ngIf="skus.length !== 0 || loadingSkus" >
      <div class="sku-box mb-3" *ngFor="let item of skus">
        <div class="item">
          <img class="img-fluid" [src]="item.image ? item.image : 'assets/images/no-image.png'" />
        </div>
        <div class="item">
          <app-sku-chip
            [value]="item.asin"
            class="item_chip"
            [name]="'ASIN'"
            [link]="
              'https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' +
              item.asin
            "
          ></app-sku-chip>
        </div>
        <div
          class="item item_row custom-scrollv2"
        >
          <div class="item_chip" [ngClass]="{ item_disable: !sku.active }" *ngFor="let sku of item.skus">
            <span class="item_chip--id" [matTooltip]="'SKU'">{{
              sku.sku
            }}</span>
            <div class="toggle-switch-sm ms-2">
              <input
                type="checkbox"
                id="{{ sku.id }}"
                [checked]="sku.active"
                (change)="sku.active = !sku.active"
              />
              <label for="{{ sku.id }}"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  class="loader" *ngIf="loadingSkus">
      <img  src="assets/images/nineyard-loading.gif" >
  </div> 
  </mat-dialog-content>
</app-dialog>
